module.exports = "/_next/static/images/rs-8d51c4ce5a5173e72dca43067aa9f7bd.svg";